export const getPlayURL = {
    methods: {
        /**
         * Get video Url for play
         * @param video Video object from server
         * @param cb Callback
         */
        getPlayURL (video, cb) {
            if (video.status !== 'ready' || video.archived) {
                return
            }

            this.$root.$emit('loading', true)
            this.$http.get('url/play/' + video.video_id).then((response) => {
                if (response) {
                    if (typeof cb === 'function') {
                        cb(response.data.url)
                    }
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.data && error.response.data.error) {
                        this.$snotify.error(error.response.data.error)
                    } else {
                        this.$snotify.error('サーバーエラー')
                    }
                }
            }).finally(() => {
                this.$root.$emit('loading', false)
            })
        }
    }
}
